// Author: Stephen Korecky
// Author: Simon Dyson
// Website: http://stephenkorecky.com
// Plugin Website: http://github.com/skorecky/Add-Clear

;(function($, window, document, undefined) {

	// Create the defaults once
	var pluginName = "addClear",
		defaults = {
			closeSymbol: "&#10006;",
			returnFocus: true,
			showOnLoad: false,
			onClear: null,
			hideOnBlur: false
		};

	// The actual plugin constructor
	function Plugin(element, options) {
		this.element = element;

		this.options = $.extend({}, defaults, options);

		this._defaults = defaults;
		this._name = pluginName;

		this.init();
	}

	Plugin.prototype = {

		init: function() {
			var $this = $(this.element),
					me = this,
					options = this.options;

			$this.wrap('<span class="clearable-wrapper"></span>');
			var $clearable = $this.closest('.clearable-wrapper');
			$this.after($('<a href="#clear" class="clearer" tabindex="-1">' + options.closeSymbol + '</a>'));

			if (options.showOnLoad === true && hasValue($this)) {
				showClearer($clearable);
			}

			$this.focus(function() {
				if (hasValue($(this))) {
					showClearer($clearable);
				}
			});

			$this.change(function() {
				if (hasValue($(this))) {
					showClearer($clearable);
				}
			});

			$this.blur(function() {
				var self = this;

				if (options.hideOnBlur) {
					setTimeout(function() {
						hideClearer($clearable);
					}, 50);
				}
			});

			$this.keyup(function() {
				if (hasValue($(this))) {
					showClearer($clearable);
				} else {
					hideClearer($clearable);
				}
			});

			$this.siblings("a[href='#clear']").click(function(e) {
				$(this).siblings(me.element).val("");
				hideClearer($clearable);
				if (options.returnFocus === true) {
					$(this).siblings(me.element).focus();
				}
				if (options.onClear) {
					options.onClear($(this).siblings("input"));
				}
				e.preventDefault();
			});
			
			function hasValue($input) {
				return $input.val().length >= 1 && $input.val() != $input.attr('placeholder');
			}

			function showClearer($clearable) {
				$clearable.addClass('has-clearer');
			}

			function hideClearer($clearable) {
				$clearable.removeClass('has-clearer');
			}
		}

	};

	$.fn[pluginName] = function(options) {
		return this.each(function() {
			if (!$.data(this, "plugin_" + pluginName)) {
				$.data(this, "plugin_" + pluginName,
					new Plugin(this, options));
			}
		});
	};

})(jQuery, window, document);